module.exports = __webpack_public_path__ + "static/media/huion-pref.d357de00.png";